import React, { useEffect, useState } from 'react';
import {
    deleteReceivedDocument, getDocuments, getDocumentsLoading, getDocumentsSendStatus, getReceivedDocDeleteStatus,
    loadDocuments, receviedDocDeleted, sendDocuments
} from '../app/store/documents';
import { useDispatch, useSelector } from 'react-redux';
import CandidateReqDoc from '../components/OMCRegistry/CandidateReqDoc';
import useDocDownload from '../app/hooks/useDocDownload';
import { getAlert, getConfirmAlert, getConfirmAlertWithAuth } from '../services/appAlerts';
import { getCurrentUser } from '../app/store/auth';
import Moment from 'react-moment';

export default function ReportingDocuments(props) {
    const { workflowTask, item } = props;
    const [reportingDocs, setReportingDocs] = useState([]);
    const [uploadDocType, setUploadDocType] = useState("");
    const [sendType, setSendType] = useState("");
    const [docShowHide, setDocShowHide] = useState(false);
    const [deleteType, setDeleteType] = useState("");

    const [handleDownloadFile] = useDocDownload();

    const documentsSelector = useSelector(getDocuments);
    const isLoading = useSelector(getDocumentsLoading);
    const receivedDocDeleteStatusSelector = useSelector(getReceivedDocDeleteStatus);
    const documentSendStatusSelector = useSelector(getDocumentsSendStatus);


    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        if (workflowTask?.ciid > 0) {
            dispatch(loadDocuments(workflowTask.ciid));
        }
    }, [workflowTask])

    useEffect(() => {
        if (documentsSelector.length > 0) {
            const rptDocs = documentsSelector.filter(x => x.uploadType === "reporting" && x.deleteFlag !== true);
            setReportingDocs(rptDocs);
        } else {
            setReportingDocs([]);
        }
    }, [documentsSelector])



    const handleDocShowHide = (type, dType) => {
        if (type === "save") {
            setDocShowHide(false);
            setSendType("");
            setUploadDocType("");
            if (workflowTask?.ciid > 0)
                dispatch(loadDocuments(workflowTask.ciid));
        } else {
            setDocShowHide(!docShowHide);
            setSendType(type);
            if (dType) setUploadDocType(dType);
        }
    };

    const handleDeleteFile = async (docId, type) => {
        const confirmDelete = await getConfirmAlertWithAuth(
            "",
            "Are you sure you want to delete this document?",
            "warning"
        );

        if (confirmDelete.isConfirmed) {
            dispatch(deleteReceivedDocument(docId, type));
            setDeleteType(type);
        }
    };

    useEffect(() => {
        if (receivedDocDeleteStatusSelector) {
            getAlert("", "Document deleted successfully", "success");
            setDeleteType("");
            dispatch(receviedDocDeleted(null));
            // Refresh document lists after deletion
            if (deleteType === "doc")
                dispatch(loadDocuments(workflowTask.ciid));
        }
    }, [receivedDocDeleteStatusSelector]);

    const handleSendDoc = async (id) => {
        const docIds = [id];
        const frm = new FormData();
        frm.append("ids", docIds);
        frm.append("userId", currentUser.id);
        frm.append("ciid", workflowTask?.ciid);
        const result = await getConfirmAlert(
            "Warning",
            "Are you sure you want to send this Document?",
            "warning"
        );
        if (result.isConfirmed) dispatch(sendDocuments(frm));

    };

    useEffect(() => {
        if (documentSendStatusSelector && workflowTask?.ciid) {
            getAlert("", "Document Sent Successfully", "success");
            dispatch(loadDocuments(workflowTask.ciid));
        }
    }, [documentSendStatusSelector]);


    const isEmpty = reportingDocs.length === 0;

    return (
        <div className="rt-rpt-panel">
            <style>{`
                .rt-rpt-panel {
                    --rpt-primary: #2563eb;
                    --rpt-primary-hover: #1d4ed8;
                    --rpt-bg-card: #ffffff;
                    --rpt-text-dark: #0f172a;
                    --rpt-text-muted: #64748b;
                    --rpt-border: #cbd5e1;
                    --rpt-radius: 12px;

                    background: var(--rpt-bg-card);
                    border: 1px solid var(--rpt-border);
                    border-radius: var(--rpt-radius);
                    box-shadow: 0 1px 3px rgba(0,0,0,0.02);
                    padding: 16px;
                    font-family: 'Outfit', 'Inter', -apple-system, sans-serif;
                    margin-top: 14px;
                }

                .rt-rpt-toolbar {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 12px;
                    gap: 12px;
                }

                .rt-rpt-title {
                    font-size: 14px;
                    font-weight: 700;
                    color: var(--rpt-text-dark);
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                .rt-rpt-title > i {
                    color: var(--rpt-primary);
                    font-size: 13px;
                }

                .rt-rpt-count {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 20px;
                    height: 18px;
                    padding: 0 6px;
                    border-radius: 999px;
                    background: #eff6ff;
                    border: 1px solid #bfdbfe;
                    color: var(--rpt-primary);
                    font-size: 10.5px;
                    font-weight: 800;
                    font-variant-numeric: tabular-nums;
                }

                .rt-rpt-empty {
                    text-align: center;
                    padding: 24px 20px;
                    color: #94a3b8;
                    background-color: #f8fafc;
                    border-radius: 10px;
                    border: 1px dashed #cbd5e1;
                }

                .rt-rpt-empty > i {
                    font-size: 26px;
                    color: #cbd5e1;
                    margin-bottom: 8px;
                    display: block;
                }

                .rt-rpt-empty-text {
                    font-size: 13px;
                    font-weight: 600;
                }

                .rt-rpt-empty-hint {
                    font-size: 11.5px;
                    font-weight: 500;
                    color: #b6c2d2;
                    margin-top: 3px;
                }

                .rt-rpt-loading {
                    text-align: center;
                    padding: 24px 20px;
                    color: #64748b;
                    background-color: #f8fafc;
                    border-radius: 10px;
                    border: 1px dashed #cbd5e1;
                }

                .rt-rpt-loading > i {
                    font-size: 22px;
                    color: var(--rpt-primary);
                    margin-bottom: 8px;
                    display: block;
                }

                .rt-rpt-loading-text {
                    font-size: 13px;
                    font-weight: 600;
                }

                .rt-rpt-upload-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    padding: 6px 14px;
                    border-radius: 8px;
                    font-size: 12.5px;
                    font-weight: 600;
                    color: #475569;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    min-height: 34px;
                }

                .rt-rpt-upload-btn:hover {
                    background: #f8fafc;
                    color: #0f172a;
                    border-color: #94a3b8;
                    transform: translateY(-1px);
                }

                .rt-rpt-list {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }

                .rt-rpt-row {
                    display: grid;
                    grid-template-columns: 32px minmax(0, 1fr) auto auto;
                    align-items: center;
                    gap: 12px;
                    background: #ffffff;
                    border: 1px solid #dbe3ef;
                    border-radius: 10px;
                    padding: 10px 12px;
                    transition: all 0.15s ease;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
                }

                .rt-rpt-row:hover {
                    border-color: #bfdbfe;
                    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.08);
                }

                .rt-rpt-file-icon {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    background: rgba(59, 130, 246, 0.08);
                    color: #3b82f6;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    flex-shrink: 0;
                }

                .rt-rpt-file-main {
                    min-width: 0;
                }

                .rt-rpt-doc-name-btn {
                    background: transparent;
                    border: none;
                    padding: 0;
                    margin: 0;
                    text-align: left;
                    font-size: 13px;
                    font-weight: 600;
                    color: var(--rpt-primary);
                    cursor: pointer;
                    transition: color 0.15s ease;
                    line-height: 1.3;
                    max-width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: block;
                }

                .rt-rpt-doc-name-btn:hover {
                    color: var(--rpt-primary-hover);
                    text-decoration: underline;
                }

                .rt-rpt-doc-meta {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin-top: 4px;
                    flex-wrap: wrap;
                }

                .rt-rpt-doc-date {
                    font-size: 12px;
                    color: #94a3b8;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }

                .rt-rpt-doc-type-badge {
                    font-size: 10px;
                    font-weight: 600;
                    color: #475569;
                    background: #f8fafc;
                    border: 1px solid #cbd5e1;
                    border-radius: 99px;
                    padding: 1px 7px;
                    display: inline-block;
                }

                .rt-rpt-status-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    padding: 4px 10px;
                    border-radius: 99px;
                    font-size: 12px;
                    font-weight: 700;
                    white-space: nowrap;
                    background: rgba(16, 185, 129, 0.08);
                    color: #047857;
                    border: 1px solid rgba(16, 185, 129, 0.15);
                }

                .rt-rpt-send-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    background: var(--rpt-primary);
                    border: 1px solid var(--rpt-primary);
                    color: #fff;
                    padding: 6px 14px;
                    border-radius: 8px;
                    font-size: 12px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    min-height: 32px;
                }

                .rt-rpt-send-btn:hover {
                    background: var(--rpt-primary-hover);
                    border-color: var(--rpt-primary-hover);
                    transform: translateY(-1px);
                    box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25);
                }

                .rt-rpt-delete-btn {
                    background: rgba(239, 68, 68, 0.06);
                    border: 1px solid rgba(239, 68, 68, 0.18);
                    color: #dc2626;
                    padding: 6px 12px;
                    border-radius: 8px;
                    font-size: 12px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 32px;
                }

                .rt-rpt-delete-btn:hover {
                    background: rgba(239, 68, 68, 0.12);
                    border-color: rgba(239, 68, 68, 0.28);
                    color: #b91c1c;
                    transform: translateY(-1px);
                }
            `}</style>
            <div className="rt-rpt-toolbar">
                <span className="rt-rpt-title">
                    <i className="fa fa-file-text-o" aria-hidden="true" /> Reporting Documents
                    {!isEmpty && (
                        <span className="rt-rpt-count">{reportingDocs.length}</span>
                    )}
                </span>
                <button
                    type="button"
                    className="rt-rpt-upload-btn"
                    onClick={() => handleDocShowHide("upload", "reporting")}
                >
                    <i className="fa fa-paperclip mr-1" /> Upload
                </button>
            </div>
            {isLoading ? (
                <div className="rt-rpt-loading">
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                    <div className="rt-rpt-loading-text">Loading reporting documents…</div>
                </div>
            ) : isEmpty ? (
                <div className="rt-rpt-empty">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                    <div className="rt-rpt-empty-text">No reporting documents uploaded.</div>
                    <div className="rt-rpt-empty-hint">Use Upload to add one.</div>
                </div>
            ) : (
            <div className="rt-rpt-list">
                {reportingDocs.map(doc => (
                    <div className="rt-rpt-row" key={doc.docId}>
                        <div className="rt-rpt-file-icon">
                            <i className="fa fa-file-text-o" aria-hidden="true" />
                        </div>
                        <div className="rt-rpt-file-main">
                            <button
                                className="rt-rpt-doc-name-btn"
                                title="Download File"
                                onClick={() => handleDownloadFile(doc)}
                            >
                                {doc.docName}
                            </button>
                            <div className="rt-rpt-doc-meta">
                                <span className="rt-rpt-doc-type-badge">Reporting</span>
                                <span className="rt-rpt-doc-date">
                                    <Moment format="MMM D, YYYY h:mm a">{doc.dateTime}</Moment>
                                </span>
                            </div>
                        </div>
                        <div className="rt-rpt-actions">
                            {!doc.sentStatus ? (
                                <button
                                    className="rt-rpt-send-btn mr-2"
                                    onClick={() => handleSendDoc(doc.docId)}
                                >
                                    <i className="fa fa-paper-plane" aria-hidden="true" /> Send
                                </button>
                            ) : (
                                <span className="rt-rpt-status-badge mr-2">
                                    <i className="fa fa-check" aria-hidden="true" /> Sent
                                </span>
                            )}
                        </div>
                        <div className="rt-rpt-delete">
                            <button
                                className="rt-rpt-delete-btn"
                                title="Delete File"
                                onClick={() => handleDeleteFile(doc.docId, "doc")}
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            )}

            {docShowHide && (
                <CandidateReqDoc
                    docShowHide={docShowHide}
                    handleDocShowHide={handleDocShowHide}
                    workItem={workflowTask}
                    sendType={sendType}
                    uploadType={"reporting"}
                    applicantObj={item}
                    viewType={""}
                    uploadDocType={uploadDocType}
                />
            )}
        </div>
    );
}